import React, { memo } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'

import { FormControl, FormControlLabel, Checkbox as MuiCheckbox } from '@mui/material'
import ErrorMessage from '../ErrorMessage'
import useStyles from './Checkbox.styled'

const Checkbox = props => {
	const { name, label, required, className, error, helperText, value, checked, onChange, onBlur, style } = props
	const classes = useStyles(props)

	return (
		<FormControl className={clsx(classes.root, className)} error={error} fullWidth style={style}>
			<FormControlLabel
				classes={{ label: classes.label }}
				control={
					<MuiCheckbox
						required={required}
						className={classes.checkbox}
						checked={checked}
						onChange={onChange}
						onBlur={onBlur}
						name={name}
						value={value}
					/>
				}
				label={label}
			/>
			{helperText && (
				<ErrorMessage className={classes.error} error={error}>
					{helperText}
				</ErrorMessage>
			)}
		</FormControl>
	)
}

Checkbox.propTypes = {
	className: PropTypes.string,
	classes: PropTypes.shape({
		root: PropTypes.string,
		checkbox: PropTypes.string,
		label: PropTypes.string,
	}),
	name: PropTypes.string.isRequired,
	value: PropTypes.bool,
	// eslint-disable-next-line react/no-unused-prop-types
	usePaperColors: PropTypes.bool,
	label: PropTypes.string,
	error: PropTypes.bool,
	helperText: PropTypes.string,
	checked: PropTypes.bool,
	required: PropTypes.bool,
	onChange: PropTypes.func,
	onBlur: PropTypes.func,
	style: PropTypes.object,
}

export default memo(Checkbox)
